import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M60 80Q40 60 50 92q10 38 50 68 40-30 50-68 10-32-10-12-20 30-40 10-20 20-40-10" }, null, -1),
    _createElementVNode("path", { d: "M78 40h10v40H78zM98 34h10v46H98zM118 42h10v38h-10z" }, null, -1),
    _createElementVNode("path", {
      stroke: "var(--mc-avatar)",
      "stroke-linecap": "round",
      "stroke-width": "5",
      d: "M100 110v30"
    }, null, -1)
  ]))]))
}
export default { render: render }